import React, { useState, useEffect } from 'react';
import { groupBy } from 'lodash';
import { EditDeletBtns } from 'components/Modal/ModalTransaction/EditDelBtns/EditDeletBtns';
import { ModalTransactions } from 'components/Modal/ModalTransaction/ModalTransaction';
import {
  CategoryStyle,
  DescriptionStyle,
  Item,
  WrapperText,
  WrapSvgText,
  Sum,
  DateTransaction,
  LocationUser,
  ImgLocation,
  SelectedItem,
  TableHeading,
} from './UniversalTransactions.styled';
import locationIcon from 'images/location.svg';
import Icons from 'images/allSvgFinTrack.svg';
import { ModalReminders } from 'components/Modal/ModalReminder/ModalReminder';
import { useSelector } from 'react-redux';
import { selectAllWallet, selectUserCurrency } from 'redux/selectors';
import { useTranslation } from 'react-i18next';
import { DebtsItemUniversal } from './DebtsItemUniversal';
import { BellRing, HandCoins, PlusCircle, Wallet } from 'lucide-react';
import { useTheme } from 'styled-components';

import ModalPaidStatus from 'components/Modal/ModalDebt/ModalPaidStatus';
import { ModalNewDebt } from 'components/Modal/ModalDebt/ModalDebt';

export const UniversalTransactions = ({
  filteredTransactions,
  getColorAndIcon,
  selectedTransactionId,
  setSelectedTransactionId,
  transactions,
  isBlurApplied,
  setIsBlurApplied,
  allTransactions,
  tableHeadingSelect,
  deleteType,
  paidStatusMarker,
  overDueType,
  modalPaidStatus,
}) => {
  const [modalEditOpen, setModalEditOpen] = useState(false);
  const [createTransactionModalOpen, setCreateTransactionModalOpen] = useState(false);
  const [createReminderModalOpen, setCreateReminderModalOpen] = useState(false);
  const [createDebtModalOpen, setCreateDebtModalOpen] = useState(false);
  const [transactionToEdit, setTransactionToEdit] = useState(null);
  const [transactionsCheck, setTransactionsCheck] = useState(false);
  const [modalDebtEditOpen, setModalDebtEditOpen] = useState(false);
  const allWallets = useSelector(selectAllWallet);
  const currencySymbol = useSelector(selectUserCurrency);
  const { t } = useTranslation();
  const titleRemainders = t('titleRemainders', { returnObjects: true });
  const titleDebts = t('titleDebts', { returnObjects: true });
  const monthTrsl = t('monthTrsl', { returnObjects: true });
  const daysTrsl = t('daysTrsl', { returnObjects: true });
  const category = t('category', { returnObjects: true });
  const debtsIcon = t('debtsIcon', { returnObjects: true });
  const scTheme = useTheme();
  const isDarkShell = scTheme.ui.scheme === 'dark';
  const isReminderView = deleteType === 'reminder' || tableHeadingSelect === true;
  const isDebtView = deleteType === 'debt';

  const emptyTitle = isReminderView
    ? t('emptyState.noReminders')
    : isDebtView
    ? t('emptyState.noDebts')
    : t('emptyState.noTransactions');
  const emptyDescription = isReminderView
    ? t('emptyState.noRemindersDesc')
    : isDebtView
    ? t('emptyState.noDebtsDesc')
    : t('emptyState.noTransactionsDesc');
  const emptyCta = isReminderView
    ? t('emptyState.createReminder')
    : isDebtView
    ? t('emptyState.createDebt')
    : t('emptyState.createTransaction');
  const addButtonLabel = isReminderView
    ? t('remindersTrsl.addRmind')
    : isDebtView
    ? t('debts.addDebts')
    : t('emptyState.createTransaction');
  const EmptyIcon = isReminderView ? BellRing : isDebtView ? HandCoins : Wallet;
  const handleCreateClick = () => {
    if (isReminderView) {
      setCreateReminderModalOpen(true);
      return;
    }
    if (isDebtView) {
      setCreateDebtModalOpen(true);
      return;
    }
    setCreateTransactionModalOpen(true);
  };

  useEffect(() => {
    if (transactions.length === 0) {
      return setTransactionsCheck(false);
    } else {
      return setTransactionsCheck(true);
    }
  }, [transactions]);

  const sortedTransactions = paidStatusMarker
    ? [...filteredTransactions].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      )
    : [...filteredTransactions].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );

  // const handleTransactionClick = (transactionId, event) => {
  //   console.log('transactionId', transactionId);
  //   if (selectedTransactionId === transactionId) {
  //     event.preventDefault();
  //     setSelectedTransactionId(null);
  //     setIsBlurApplied(false);
  //   } else {
  //     setSelectedTransactionId(transactionId);
  //     setIsBlurApplied(true);
  //   }
  // };
  const handleTransactionClick = (transactionId, event) => {
    if (selectedTransactionId === transactionId) {
      event.preventDefault();
      setSelectedTransactionId(null);
      setIsBlurApplied(false);
    } else {
      setSelectedTransactionId(transactionId);
      setIsBlurApplied(true);
    }
  };

  const groupedTransactions = groupBy(sortedTransactions, transaction => {
    const dateObj = new Date(transaction.date || transaction.createdAt);
    const month = dateObj.toLocaleDateString('en-US', { month: 'long' });
    const translatedMonth = monthTrsl[month];
    const translatedDayOfWeek =
      daysTrsl[dateObj.toLocaleDateString('en-US', { weekday: 'long' })];
    const dayOfMonth = dateObj.getDate();
    const fullDate = dateObj.toLocaleDateString('en-US', {
      year: 'numeric',
    });
    return `${translatedDayOfWeek}, ${dayOfMonth}, ${translatedMonth},  ${fullDate}`;
  });

  const handleEditClick = transaction => {
    if (deleteType === 'debt') {
      setModalDebtEditOpen(true);
      setTransactionToEdit(transaction);

      setModalEditOpen(false);
    } else {
      setTransactionToEdit(transaction);
      setModalEditOpen(true);
      setModalDebtEditOpen(false);
    }
  };
  const findWalletName = (data, id, Wallets) => {
    const matchingData = data.find(obj => obj.walletId === id);

    if (matchingData) {
      const matchingWallet = Wallets.find(
        wallet => wallet._id === matchingData.walletId
      );

      if (matchingWallet) {
        return matchingWallet.name;
      }
    }

    return 'Unknown wallet';
  };

  return (
    <>
      {modalEditOpen &&
        transactionToEdit &&
        (tableHeadingSelect !== true ? (
          <ModalTransactions
            onClose={() => {
              setModalEditOpen(false);
              setTransactionToEdit(null);
              setModalDebtEditOpen(false);
            }}
            transactionToEdit={transactionToEdit}
          />
        ) : (
          <ModalReminders
            onClose={() => {
              setModalEditOpen(false);
              setTransactionToEdit(null);
              setModalDebtEditOpen(false);
            }}
            transactionToEdit={transactionToEdit}
          />
        ))}
      {modalDebtEditOpen && (
        <ModalPaidStatus
          debt={transactionToEdit}
          overDueType={overDueType}
          onClose={() => {
            setModalDebtEditOpen(false);
          }}
        />
      )}
      {createTransactionModalOpen && (
        <ModalTransactions
          onClose={() => {
            setCreateTransactionModalOpen(false);
          }}
        />
      )}
      {createReminderModalOpen && (
        <ModalReminders
          onClose={() => {
            setCreateReminderModalOpen(false);
          }}
        />
      )}
      {createDebtModalOpen && (
        <ModalNewDebt
          onClose={() => {
            setCreateDebtModalOpen(false);
          }}
        />
      )}
      <div className="mb-3 flex items-center justify-between gap-3">
        <TableHeading
          className={`!m-0 !text-left !font-heading !text-lg !tracking-normal ${
            isDarkShell ? '!text-slate-100' : '!text-slate-900'
          }`}
        >
          {allTransactions
            ? t('tableTrans.title')
            : tableHeadingSelect
            ? titleRemainders
            : overDueType
            ? ''
            : titleDebts}
        </TableHeading>
        {((isReminderView || isDebtView) && transactionsCheck) || allTransactions ? (
          <button
            type="button"
            onClick={handleCreateClick}
            className={`inline-flex items-center gap-2 rounded-2xl border px-3 py-2 text-xs font-semibold text-[#FF7601] shadow-sm transition ${
              isDarkShell
                ? 'border-slate-600 bg-slate-800 hover:bg-slate-700/90'
                : 'border-orange-100 bg-white hover:bg-orange-50'
            }`}
          >
            <PlusCircle size={14} />
            {allTransactions ? t('emptyState.createTransaction') : addButtonLabel}
          </button>
        ) : null}
      </div>

      {transactionsCheck ? (
        <ul>
          {Object.keys(groupedTransactions).map(date => (
            <React.Fragment key={date}>
              <DateTransaction>{date}</DateTransaction>
              {groupedTransactions[date].map(transaction => {
                const { color, position } = getColorAndIcon(
                  transaction.operation
                );

                const isTransactionSelected =
                  selectedTransactionId === transaction._id;
                const TransactionItem = isTransactionSelected
                  ? SelectedItem
                  : Item;

                return (
                  <React.Fragment key={transaction._id}>
                    {deleteType === 'debt' ? (
                      <TransactionItem
                        modalPaidStatus={modalPaidStatus}
                        deleteType={deleteType}
                        onClick={event =>
                          handleTransactionClick(transaction._id, event)
                        }
                        isTransactionSelected={isTransactionSelected}
                        style={
                          isBlurApplied && !isTransactionSelected
                            ? { filter: 'blur(2px)' }
                            : {}
                        }
                      >
                        <ul>
                          <DebtsItemUniversal
                            transaction={transaction}
                            Icons={Icons}
                            deleteType={deleteType}
                            color={color}
                            position={position}
                            selectedTransactionId={selectedTransactionId}
                            handleEditClick={handleEditClick}
                            tableHeadingSelect={tableHeadingSelect}
                            paidStatusMarker={paidStatusMarker}
                            setModalDebtEditOpen={setModalDebtEditOpen}
                            onClose={() => {
                              setModalDebtEditOpen(false);
                              setModalEditOpen(false);
                            }}
                          />
                        </ul>
                      </TransactionItem>
                    ) : (
                      <TransactionItem
                        onClick={event =>
                          handleTransactionClick(transaction._id, event)
                        }
                        isTransactionSelected={isTransactionSelected}
                        style={
                          isBlurApplied && !isTransactionSelected
                            ? { filter: 'blur(2px)' }
                            : {}
                        }
                      >
                        <WrapSvgText>
                          <svg width={24} height={24} fill={'#FF7601'}>
                            <use href={`${Icons}#${transaction.icon}`} />
                          </svg>

                          <WrapperText
                            deleteType={deleteType}
                            modalPaidStatus={modalPaidStatus}
                          >
                            <CategoryStyle
                              text={
                                category[transaction.icon]
                                  ? category[transaction.icon].categoryName
                                  : debtsIcon[transaction.icon]
                                  ? debtsIcon[transaction.icon].categoryName
                                  : ''
                              }
                              length={14}
                            />
                            {transaction.walletId === undefined ? (
                              <svg width={24} height={24} fill={'#FF7601'}>
                                <use
                                  href={`${Icons}#${
                                    getColorAndIcon(transaction.operation).icon
                                  }`}
                                />
                              </svg>
                            ) : (
                              <DescriptionStyle
                                text={findWalletName(
                                  transactions,
                                  transaction.walletId,
                                  allWallets
                                )}
                                length={10}
                              />
                            )}

                            <DescriptionStyle
                              text={transaction.description}
                              length={20}
                            />
                            {transaction.operation === undefined ? (
                              ''
                            ) : (
                              <LocationUser>
                                <ImgLocation
                                  src={locationIcon}
                                  alt="locationIcon"
                                />
                              </LocationUser>
                            )}
                          </WrapperText>
                        </WrapSvgText>
                        <Sum
                          style={{
                            color: color,
                          }}
                        >
                          {position} {currencySymbol}{' '}
                          {transaction.sum.toFixed(0)}
                        </Sum>
                        {selectedTransactionId === transaction._id && (
                          <EditDeletBtns
                            data={transaction}
                            transactionId={transaction._id}
                            selectedTransactionId={selectedTransactionId}
                            handleEditClick={handleEditClick}
                            tableHeadingSelect={tableHeadingSelect}
                            deleteType={deleteType}
                            setModalDebtEditOpen={setModalDebtEditOpen}
                            paidStatusMarker={paidStatusMarker}
                          />
                        )}
                      </TransactionItem>
                    )}
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          ))}
        </ul>
      ) : (
        <div
          className={`relative mt-3 rounded-3xl border p-8 text-center ${
            isDarkShell
              ? 'border-slate-600 bg-slate-800/80'
              : 'border-slate-200 bg-slate-50/70'
          }`}
        >
          <EmptyIcon
            size={42}
            className={`mx-auto mb-4 rounded-2xl p-2 text-[#FF7601] ${
              isDarkShell ? 'bg-slate-900' : 'bg-orange-100'
            }`}
          />
          <p
            className={`mb-2 font-heading text-xl font-semibold ${
              isDarkShell ? 'text-slate-100' : 'text-slate-900'
            }`}
          >
            {emptyTitle}
          </p>
          <p
            className={`mx-auto mb-5 max-w-sm text-sm ${
              isDarkShell ? 'text-slate-400' : 'text-slate-500'
            }`}
          >
            {emptyDescription}
          </p>
          <button
            type="button"
            onClick={handleCreateClick}
            className="mx-auto inline-flex items-center gap-2 rounded-2xl bg-[#FF7601] px-4 py-2 text-sm font-semibold text-white shadow-sm"
          >
            <PlusCircle size={16} />
            {emptyCta}
          </button>
        </div>
      )}
    </>
  );
};
